import { z } from 'zod';

/** Pasos del editor (módulo mínimo: lo importa `router.tsx` para validar `?step=` sin cargar la pantalla). */
export const CAMPAIGN_STEP_IDS = [
  'basics',
  'audience',
  'channels',
  'content',
  'extras',
  'template',
  'test',
  'approve',
] as const;
export type CampaignStep = (typeof CAMPAIGN_STEP_IDS)[number];

export const CAMPAIGN_STEPS: ReadonlyArray<{ id: CampaignStep; label: string; title: string }> = [
  { id: 'basics', label: 'Datos', title: 'Nombre, consentimiento e idiomas' },
  { id: 'audience', label: 'Audiencia', title: 'A quién llega' },
  { id: 'channels', label: 'Canales', title: 'Por dónde llega: correo, WhatsApp o un canal por persona' },
  { id: 'content', label: 'Contenido', title: 'Qué dice el correo' },
  { id: 'extras', label: 'Cupón y A/B', title: 'Cupón único y prueba de asuntos (opcional)' },
  { id: 'template', label: 'Plantilla', title: 'Plantilla en Fidelizador' },
  { id: 'test', label: 'Prueba', title: 'Prueba en tu correo' },
  { id: 'approve', label: 'Aprobación', title: 'Aprobación y envío' },
];

export const campaignsListSearchSchema = z.object({
  tenant: z.string().optional(),
  /** Estado VISIBLE (`displayStatus`, derivado en el servidor): lleva `scheduled`. */
  status: z.enum(['draft', 'scheduled', 'approved', 'sending', 'done', 'cancelled']).optional().catch(undefined),
});
export const campaignNewSearchSchema = z.object({
  tenant: z.string().optional(),
  /** `automation` = plantilla de un disparador automático. */
  kind: z.enum(['automation']).optional().catch(undefined),
});
export const campaignEditSearchSchema = z.object({
  tenant: z.string().optional(),
  step: z.enum(CAMPAIGN_STEP_IDS).optional().catch(undefined),
});
